export enum DisplayDefinitionEntryType {
    Number = 'NUMBER',
    String = 'STRING',
    Date = 'DATE',
    Boolean = 'BOOLEAN',
    EnumList = 'ENUMLIST',
    Enum = 'ENUM',
}
